<template>
  <ion-app>
    <div class="ion-page">
      <ion-header>
        <ion-toolbar color="dark" mode="ios">
          <ion-buttons mode="ios">
            <ion-back-button></ion-back-button>
          </ion-buttons>
          <ion-title>Self Order</ion-title>
        </ion-toolbar>
      </ion-header>

      <ion-content v-if="((paymentSuccess || invoiceId) && hasActiveOrder === '1')" class="ion-padding ion-text-center">
        <div class="success-container">
          <div>
            <div class="success-wrapper">
              <div class="checkmark-wrapper">
                <div class="checkmark"></div>
              </div>
            </div>

            <ion-item-divider>
              <ion-row class="ion-justify-content-center ion-align-items-center ion-text-center">
                <h2 class="success-title">{{ alertTitle }}</h2>
                <p class="success-subtitle">Terima kasih! Pesanan Anda sedang diproses.</p>
              </ion-row>
            </ion-item-divider>

            <ion-item-divider>
              <ion-row class="ion-justify-content-center ion-align-items-center ion-text-center">
                <h5 class="number-title">NOMOR PESANAN ANDA</h5>
                <h1 class="number-invoice">#{{ currentInvoice }}</h1>
                <OrderStepper :status="orderStatus" />
              </ion-row>
            </ion-item-divider>

            <p class="title-1">Apa Selanjutnya?</p>
            <p class="subtitle-1">Silahkan tunggu nomor pesanan Anda <br />(#{{ currentInvoice }}) sedang disiapkan</p>

            <div class="order-list">
              <div v-for="order in currentOrder" :key="order.product_id" class="order-item">

                <ion-img
                  :src="order.photo !== '' ? order.photo : 'https://res.cloudinary.com/dxcleuxwe/image/upload/v1758687442/placeholder/no-product-image_v7tdrr.png'"
                  class="order-thumb" />

                <div class="order-info">
                  <div class="order-name">{{ order.product_name }}</div>
                  <div class="order-meta">
                    x{{ order.qty }} • Rp {{ order.price.toLocaleString("id-ID") }}
                  </div>
                </div>

              </div>
            </div>
          </div>

          <!-- card wa -->
          <div class="wa-card" v-show="!disabledWaButton">
            <div class="wa-card-content">
              <h4 class="wa-title">Jangan takut ketinggalan info pesanan</h4>
              <p class="wa-subtitle">
                Biar gak nunggu lama, kami akan kirim pesan saat stok dikonfirmasi.
              </p>
              <button class="wa-button" @click="sendWaNotification">
                <ion-icon :icon="logoWhatsapp" class="wa-icon"></ion-icon>
                Ingatkan Saya via WhatsApp
              </button>
            </div>
          </div>

          <ion-button class="success-btn" expand="block" color="success" @click="goToOutlet">
            Jelajahi Menu Lagi
          </ion-button>

          <ion-button @click="goToDoku" v-if="app_lastPayment" class="success-btn" expand="block" color="danger">
            Cek status pembayaran
          </ion-button>

          <p style="color: gray;">Tenang, status pesanan Anda akan muncul di bagian bawah layar jika Anda kembali ke
            menu.</p>
        </div>
      </ion-content>

      <ion-content v-else>
        <ion-card class="input-card">
          <h3>Selesaikan Pembayaran</h3>
          <p>Total Pembayaran</p>

          <ion-card color="light" class="ion-text-center ion-card-self-order">
            <div class="qr-wrapper">
              <ion-img class="qrcode data-private" :src="qrcode" alt="No Image"></ion-img>
            </div>
          </ion-card>

          <h3>Batas Waktu Pembayaran</h3>
          <p class="timer">{{ formattedTime }}</p>

          <div>
            <ion-button @click="saveQRCode()" expand="block" class="save-btn">
              UNDUH KODE QR
            </ion-button>

            <ion-button @click="goToDoku" expand="block" color="danger">
              GO TO Payment
            </ion-button>
          </div>

          <h4>Cara Pembayaran</h4>
          <ul>
            <li>1. Screenshot atau unduh QR Code di atas.</li>
            <li>2. Buka aplikasi e-wallet atau m-banking Anda.</li>
            <li>2. Pilih fitur 'Bayar' atau 'Scan QR' dan unggah gambar.</li>
          </ul>
        </ion-card>
      </ion-content>

    </div>
  </ion-app>
</template>

<script>
import { useOutletStore } from "@/stores/outlet"
import OrderStepper from "@/components/OrderStepper";
import { IonHeader, IonToolbar, IonButtons, IonBackButton, IonTitle, IonContent, IonButton, IonCard, IonItemDivider, IonRow, IonApp, IonImg, IonIcon } from "@ionic/vue";
import { storage, STORAGE_KEYS, getCurrentInvoice } from "@/utils/storage";
import { logoWhatsapp } from "ionicons/icons";

export default {
  components: {
    OrderStepper,
    IonHeader,
    IonToolbar,
    IonButtons,
    IonBackButton,
    IonTitle,
    IonContent,
    IonButton,
    IonCard,
    IonItemDivider,
    IonRow,
    IonApp,
    IonImg,
    IonIcon
  },
  setup() {
    return { logoWhatsapp };
  },
  data() {
    return {
      timeLeft: 720,
      timer: null,
      qrcode: "",
      paymentSuccess: false,
      orderStatus: "diterima",
      currentOrder: [],
      currentInvoice: "",
      hasActiveOrder: "0",
      alertTitle: "Pembayaran Berhasil",
      lastPayment: null,
      disabledWaButton: false,
    }
  },
  computed: {
    formattedTime() {
      const minutes = Math.floor(this.timeLeft / 60).toString().padStart(2, "0")
      const seconds = (this.timeLeft % 60).toString().padStart(2, "0")
      return `${minutes}:${seconds}`
    },
    outletStore() {
      return useOutletStore()
    },
    invoiceId() {
      return this.$route.query['invoice-id']
    }
  },
  created() {
    this.lastPayment = storage.getLastPayment() ? storage.getLastPayment() : null

    this.paymentSuccess = storage.getPaymentSuccess() || false

    const paymentDeadline = storage.getPaymentOrderDeadline()
    if (paymentDeadline !== undefined) {

      const dateNow = Math.floor(Date.now() / 1000);
      if (dateNow >= paymentDeadline) {
        storage.removeMultiple([
          STORAGE_KEYS.PAYMENT_ORDER_DEADLINE,
          STORAGE_KEYS.HAS_ACTIVE_ORDER,
          STORAGE_KEYS.ACTIVE_ORDER,
          STORAGE_KEYS.CURRENT_INVOICE,
          STORAGE_KEYS.LAST_ORDER_STATUS,
          STORAGE_KEYS.LAST_ORDER,
          STORAGE_KEYS.PAYMENT_SUCCESS,
        ])
        this.goToOutlet()
      }
    }
    const deadline = storage.getPaymentDeadline()
    if (deadline) {
      const now = Math.floor(Date.now() / 1000)
      const diff = parseInt(deadline, 10) - now;
      this.timeLeft = diff > 0 ? diff : 0;

    } else {
      const newDeadLine = Math.floor(Date.now() / 1000) + this.timeLeft;

      storage.setPaymentDeadline(newDeadLine)
    }
  },
  methods: {
    async sendWaNotification() {
      console.log("Mendaftarkan notifikasi WA...");
      const invoice = this.outletStore.currentInvoice;
      if (!invoice) {
        console.warn("Invoice is empty, redirecting to home...");
        this.goToOutlet()
        return;
      }
      const url = `${process.env.VUE_APP_BASE_URL}v1/orders/subscribe-request`;

      const myHeaders = new Headers();
      myHeaders.append("Public-Key", `${process.env.VUE_APP_PUBLIC_KEY}=`);
      // Tambahkan Content-Type agar server mengenali JSON body
      myHeaders.append("Content-Type", "application/json");

      const body = {
        order_id: invoice
      };

      const requestOptions = {
        method: "POST",
        body: JSON.stringify(body),
        headers: myHeaders,
      };

      try {
        const res = await fetch(url, requestOptions);
        if (res.ok) {
          const result = await res.json();

          // Mengambil URL WhatsApp dari data respon
          const whatsappUrl = result.data.whatsapp_url;

          if (whatsappUrl) {
            // Cara 1: Buka di tab baru (direkomendasikan agar aplikasi Anda tetap terbuka)
            window.open(whatsappUrl, '_blank');

            // Cara 2: Redirect langsung di tab yang sama
            // window.location.href = whatsappUrl;
          }
        } else {
          console.error("Gagal mendapatkan link WhatsApp, status:", res.status);
          this.goToOutlet()
        }
      } catch (error) {
        console.error("Error:", error);
      }
    },
    goToOutlet() {
      const id = this.$route.params.id;
      this.$router.push(`/${id}`)
      // clearInterval(this.checkStatusTimer)
    },
    goToDoku() {
      window.location.href = this.lastPayment.data.payment_info.value;
    },
    async checkPaymentStatus() {
      const outlet_id = this.$route.params.id;
      this.checkStatusTimer = setInterval(async () => {
        const newDeadline = Math.floor(Date.now() / 1000) + 24 * 60 * 60;
        if (storage.getPaymentOrderDeadline() === undefined) {
          storage.setPaymentOrderDeadline(newDeadline)
        }

        this.currentInvoice = getCurrentInvoice() || this.outletStore.currentInvoice
        const url = `${process.env.VUE_APP_BASE_URL}v2/transaction/${this.currentInvoice}`

        const myHeaders = new Headers();
        myHeaders.append("Public-Key", `${process.env.VUE_APP_PUBLIC_KEY}=`);


        const requestOptions = {
          method: "GET",
          headers: myHeaders,
        };

        const res = await fetch(url, requestOptions)
        if (res.ok) {
          const data = await res.json()
          console.log(data.data.customer.subscription.whatsapp.active)
          if (data.data.customer.subscription.whatsapp.active) {
            this.disabledWaButton = true;
          }
          if (data.data.status === "payment_verified") {
            const lastOrder = storage.getLastOrder()
            if (lastOrder && lastOrder.outelt_id == outlet_id) {
              storage.setActiveOrder({ outlet_id, products: lastOrder.products })
            }

            storage.removeMultiple([
              STORAGE_KEYS.PAYMENT_DEADLINE,
              STORAGE_KEYS.LAST_ORDER,
              STORAGE_KEYS.ORDER_DEADLINE,
              STORAGE_KEYS.LAST_PAYMENT,
            ])

            storage.setHasActiveOrder("1")
            storage.setLastOrderStatus("disiapkan")
            storage.setPaymentSuccess(true)

            this.paymentSuccess = true;
            this.orderStatus = "disiapkan";
            this.alertTitle = "Sedang Disiapkan"
          }

          if (data.data.status === "ready") {
            storage.setLastOrderStatus("siap")
            this.orderStatus = "siap"
            this.alertTitle = "Pesanan Siap"
            // clearInterval(this.checkStatusTimer)

            setTimeout(() => {
              // localStorage.removeItem("app_has_active_order")
              // localStorage.removeItem("app_active_order")
              // localStorage.removeItem("currentInvoice")
              // localStorage.removeItem("app_last_order_status")
              // this.goToOutlet()
            }, 5000);
          }

          if (data.data.status === "cancel") {
            storage.removeMultiple([
              STORAGE_KEYS.HAS_ACTIVE_ORDER,
              STORAGE_KEYS.LAST_PAYMENT,
              STORAGE_KEYS.LAST_ORDER_STATUS,
              STORAGE_KEYS.PAYMENT_ORDER_DEADLINE,
              STORAGE_KEYS.HAS_ACTIVE_ORDER,
              STORAGE_KEYS.ACTIVE_ORDER,
              STORAGE_KEYS.PAYMENT_SUCCESS,
              STORAGE_KEYS.CURRENT_INVOICE
            ])
            clearInterval(this.checkStatusTimer)
            this.$router.push("/")
          }

          if (data.data.status === "taken") {
            // localStorage usage
            storage.setLastOrderStatus("taken")
            this.orderStatus = "taken";
            this.alertTitle = "Pesanan Sudah Diambil";
            clearInterval(this.checkStatusTimer)
          }

          this.lastPayment = storage.getLastPayment() ? storage.getLastPayment() : null
        }
      }, 5000);
    },
    saveQRCode() {
      const link = document.createElement("a")
      link.href = this.qrcode
      link.download = "qrcode.png"
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    startTimer() {
      this.timer = setInterval(() => {
        if (this.timeLeft > 0) {
          this.timeLeft--
        } else {
          clearInterval(this.timer)
          storage.removeMultiple([
            STORAGE_KEYS.LAST_PAYMENT,
            STORAGE_KEYS.PAYMENT_DEADLINE,
            STORAGE_KEYS.ORDER_DEADLINE,
            STORAGE_KEYS.HAS_ACTIVE_ORDER,
            STORAGE_KEYS.CURRENT_INVOICE,
            STORAGE_KEYS.LAST_ORDER_STATUS,
            STORAGE_KEYS.ACTIVE_ORDER,
            STORAGE_KEYS.LAST_ORDER,
            STORAGE_KEYS.PAYMENT_ORDER_DEADLINE,
            STORAGE_KEYS.PAYMENT_SUCCESS
          ])

          const outlet = this.outletStore.outlet;

          this.$router.push(`/${outlet.outlet_id}`)
        }
      }, 1000);
    },
    setDataPayment() {
      const lastPayment = storage.getLastPayment()
      if (lastPayment) {
        try {
          const lastPaymentObj = lastPayment
          this.qrcode = lastPaymentObj?.data?.payment_info?.value
        } catch (error) {
          console.error("Error parsing payment data:", error)
        }
      }
    }
  },
  mounted() {
    const outlet_id = this.$route.params.id;
    this.hasActiveOrder = storage.getHasActiveOrder()
    const activeOrder = storage.getActiveOrder()
    if (activeOrder && activeOrder.outlet_id == outlet_id) {
      this.currentOrder = activeOrder.products;
    }
    this.orderStatus = storage.getLastOrderStatus() ?? "diterima"
    if (this.orderStatus == "diterima") {
      this.alertTitle = "Pembayaran Berhasil"
    } else if (this.orderStatus == "disiapkan") {
      this.alertTitle = "Sedang Disiapkan"
    } else if (this.orderStatus == "siap") {
      this.alertTitle = "Pesanan Siap"
    }
    this.currentInvoice = getCurrentInvoice() || this.outletStore.currentInvoice
    this.startTimer()
    this.checkPaymentStatus()
    this.setDataPayment()
  }
}
</script>

<style scoped>
.input-card {
  margin: 1rem 0.5rem 1rem 0.5rem;
  box-shadow: none;
  background: #f5f5f5;
  padding: 0 0.8rem;
  height: calc(100vh - 70px);
}

.input-card h3,
p {
  text-align: center;
}

.qr-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  /* margin: 3rem; */
}

.timer {
  font-size: 3rem;
  line-height: 0;
  font-weight: bold;
  color: #d9833b;
}

.save-btn {
  /* margin: 0 0.5rem 1rem 0.5rem; */
  --box-shadow: none;
  --background: #d9833b;
}

ul {
  margin-left: -1rem;
  margin-top: -0.2rem;
}

ul li {
  font-size: 16px;
}

.qrcode {
  width: 100%;
  height: 100%;
}

.success-container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  /* vertical center */
  align-items: center;
  /* horizontal center */
  min-height: 100vh;
  /* full height of ion-content */
  text-align: center;
}


.success-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 50px;
}

.checkmark-wrapper {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #59d45d;
  position: relative;
  animation: pop 0.6s ease-out forwards;
  box-shadow: 0 0 20px rgba(76, 175, 80, 0.5);
}

.checkmark {
  width: 35px;
  height: 60px;
  border-right: 15px solid #fff;
  border-bottom: 15px solid #fff;
  transform: rotate(45deg) scale(0);
  animation: draw 0.6s 0.4s ease forwards;
}

@keyframes draw {
  to {
    transform: rotate(45deg) scale(1);
  }
}

@keyframes pop {
  0% {
    transform: scale(0.5);
  }

  70% {
    transform: scale(1.1);
  }

  100% {
    transform: scale(1);
  }
}

.success-title {
  margin-top: 20px;
  font-size: 24px;
  font-weight: bold;
  color: #4caf50;
}

.success-subtitle {
  margin: 10px 0 30px;
  font-size: 16px;
  color: #666;
}

.success-btn {
  width: 100%;
}

hr {
  background: #999;
}

.number-title {
  color: gray;
}

.number-invoice {
  margin-top: 0;
  font-size: 2rem;
  font-weight: 500;
}

.title-1 {
  font-size: 1.1rem;
  font-weight: bold;
}

.subtitle-1 {
  color: gray;
}

.order-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin: 16px 0;
}

.order-item {
  display: flex;
  align-items: center;
  gap: 12px;
  background: #ffffff;
  border-radius: 10px;
  padding: 10px 12px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
}

.order-thumb {
  width: 52px;
  height: 52px;
  border-radius: 8px;
  object-fit: cover;
}

.order-info {
  display: flex;
  flex-direction: column;
}

.order-name {
  font-weight: 600;
  font-size: 14px;
  color: #111827;
  text-align: start;
}

.order-meta {
  font-size: 13px;
  color: #6b7280;
  text-align: start;
}


.wa-card {
  background: #ffffff;
  border-radius: 20px;
  padding: 20px;
  margin: 1.5rem 0;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
  width: 100%;
  max-width: 400px;
  border: 1px solid #f0f0f0;
}

.wa-card-content {
  text-align: left;
}

.wa-title {
  margin: 0 0 8px 0;
  font-size: 1.1rem;
  font-weight: 800;
  color: #333;
  text-align: left;
  /* Mengoverride text-align center p global */
}

.wa-subtitle {
  margin: 0 0 20px 0;
  font-size: 0.9rem;
  color: #666;
  line-height: 1.4;
  padding: 0;
  /* Reset padding dari p global */
  text-align: left;
}

.wa-button {
  background: #25d366;
  /* Warna khas WhatsApp */
  color: white;
  border: none;
  border-radius: 50px;
  padding: 14px 24px;
  font-weight: 700;
  font-size: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100%;
  box-shadow: 0 4px 12px rgba(37, 211, 102, 0.3);
  transition: transform 0.2s;
}

.wa-button:active {
  transform: scale(0.98);
}

.wa-icon {
  font-size: 1.5rem;
}

/* Pastikan card utama tidak membatasi tinggi jika konten bertambah */
.input-card {
  height: auto;
  /* Ubah dari calc(100vh - 70px) agar bisa scroll jika layar kecil */
  min-height: calc(100vh - 70px);
}
</style>